export default __webpack_public_path__ + "static/media/AutoVD3.3ef6e485.png";